import React, { useEffect, useState } from 'react'
import { Row, Col, Button, Input } from 'antd'
import { translate } from 'react-i18next'
import {
    updateAnnouncement
} from '../../helpers'
import { useSelector, useDispatch } from 'react-redux'
import { showSpinner, hideSpinner } from '../../redux/actions/actions'

const EditAnnouncement = ({ setIsEdit, t }) => {
    const { TextArea } = Input
    const dispatch = useDispatch()
    const [announcementInput, setAnnouncementInput] = useState('')
    const announcement = useSelector(state => state.lobby.announcement)
    const onEditText = (text) => {
        const value = text.target.value
        if (value.length <= 1500)
            setAnnouncementInput(value);
    }
    const onUpdateAnnouncement = async () => {
        dispatch(showSpinner)
        await updateAnnouncement(announcementInput)
        dispatch(hideSpinner)
        setIsEdit(false)
    }
    useEffect(() => {
        setAnnouncementInput(announcement)
    }, [announcement])
    return (
        <>
            <div className="lobby-announcement">
                <div className="announcement-header">
                    <div>{t("lobby_announcement")}</div>
                    <div>
                        <Button style={{ width: 120 }} className="btn-outline" onClick={() => setIsEdit(false)}>
                            {t("lobby_modal.cancel")}
                        </Button>
                        <Button style={{ width: 120, marginRight: 0 }} className="btn-danger" onClick={onUpdateAnnouncement}>{t("lobby_modal.update")}</Button>
                    </div>
                </div>
                <div className="announcement-detail">
                    <Row>
                        <Col span={24}>
                            <TextArea
                                placeholder={t("lobby_announcement_placeholder")}
                                rows={11}
                                style={{ margin: '10px 0' }}
                                value={announcementInput}
                                onChange={onEditText} />
                        </Col>
                    </Row>
                </div>
            </div>
        </>
    )
}

export default translate()(EditAnnouncement)